import React, { useState, useEffect } from "react";

export default function CountdownTimer({ initialSeconds = 30, onResend, disabled = false }) {
  const [secondsLeft, setSecondsLeft] = useState(initialSeconds);
  const [isResending, setIsResending] = useState(false);

  useEffect(() => {
    if (secondsLeft <= 0) return;

    const timer = setInterval(() => {
      setSecondsLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [secondsLeft]);

  const handleResendClick = async () => {
    if (secondsLeft > 0 || isResending || disabled) return;
    setIsResending(true);
    try {
      if (onResend) {
        await onResend();
      }
      setSecondsLeft(initialSeconds);
    } catch (err) {
      console.error("Resend error:", err);
    } finally {
      setIsResending(false);
    }
  };

  return (
    <div style={{ textAlign: "center", marginTop: "16px", fontSize: "14px", color: "#6c757d" }}>
      {secondsLeft > 0 ? (
        <p style={{ margin: 0 }}>
          Resend OTP in <strong style={{ color: "#5e3bee" }}>{secondsLeft}s</strong>
        </p>
      ) : (
        <p style={{ margin: 0 }}>
          Didn't receive the OTP?{" "}
          <button
            type="button"
            onClick={handleResendClick}
            disabled={disabled || isResending}
            style={{
              background: "none",
              border: "none",
              color: "#5e3bee",
              fontWeight: "600",
              textDecoration: "underline",
              cursor: disabled || isResending ? "not-allowed" : "pointer",
              padding: 0,
              fontSize: "14px",
            }}
          >
            {isResending ? "Resending..." : "Resend OTP"}
          </button>
        </p>
      )}
    </div>
  );
}
